module.exports = __webpack_public_path__ + "img/11.1dbe2537.png";